import * as Types from './types';
import { useEffect } from 'react';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

export const CAF = ({ config }: Types.CAFOptions) => {
    const {
        // general config
        sdkUrl = ''
    } = config;

    useEffect(() => {
        window['@combateafraude/identity-sdk-url'] = sdkUrl;
    }, [sdkUrl]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.caf]: CAF });
